// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"6dcefa06","170":"cd278469","603":"6dcefa06"}[chunkId] + ".chunk.css";
};